module.exports = __webpack_public_path__ + "img/bus-partner-img9.3d62014d.png";